import { apim } from "@/constants/api"
import {
  CHANGE_PASSWORD_ENDPOINT,
  CATALOG_PROJECTION_ENDPOINT,
} from "@/constants/routes"
import {
  searchPdpEndPoint,
  skuBypimLookup,
  SEARCH_PDP_FL,
} from "@/constants/index"
import { getSessionIdObjWithEpoc } from "@/utils/ApiUtil"
import { getConfig } from "@/constants/config"

export const requestForChangePassword = async data => {
  try {
    return await apim.post(CHANGE_PASSWORD_ENDPOINT, data)
  } catch (err) {
    console.error("Failed to reset password", err)
    return err.response
  }
}

export const getProductByImage = async input => {
  try {
    const response = await apim.post(`${skuBypimLookup}`, input, {
      sessionId: getSessionIdObjWithEpoc(),
    })
    return response
  } catch (err) {
    return err
  }
}
export const getSearchPDP = async (slug, isParts = true) => {
  try {
    const config = await getConfig()
    const language = config?.internationalization?.language ?? "en"
    const data = {
      collections: isParts ? "service_parts" : "kohler",
      fl: SEARCH_PDP_FL.toString(),
      profilename: isParts ? "profile_service_parts_PDP" : "profile_kohler_PDP",
      q: "*:*",
      search_type: "product_detail",
      fq: `language_s:("${language}")`,
    }
    const response = await apim.post(`${searchPdpEndPoint}/${slug}`, data)
    if (!response?.data?.response?.docs.length) {
      data.collections = "kohler"
      data.profilename = "profile_kohler_General"
      return await apim.post(`${searchPdpEndPoint}/${slug}`, data)
    }
    return response
  } catch (err) {
    return err
  }
}
export const getProjectionData = async payload => {
  const { slug, skus } = payload
  let query = ""
  let masterQuery = ""
  if (slug) masterQuery += `slug(en-US%3D"${slug}") or `
  if (skus.length > 0) {
    skus.forEach((sku, i) => {
      query += `"${sku}"`
      if (i + 1 !== skus.length) query += ", "
    })
    masterQuery += `masterVariant(sku in (${query})) or variants(sku in (${query}))`
  }
  try {
    const res = await apim.get(
      `${CATALOG_PROJECTION_ENDPOINT}?where=${masterQuery}`
    )
    if (res && res.data && res.data.results) return res.data.results
  } catch (err) {
    return err
  }
  return []
}
